import React from 'react'
import { ErrorMessage, useFormikContext } from 'formik'
import DropdownIcon from 'icons/dropdown'

// A correct Formik-bound native <select>. The shared components/select.js is
// broken (it recursively renders itself), so restaurant modules use this.
function NativeSelect({ name, label, options = [], placeholder, required }) {
  const formik = useFormikContext()

  return (
    <div className='tw-grow tw-flex tw-flex-col tw-gap-[7px]'>
      {label && (
        <div className='tw-text-[#4A403A] tw-text-[15px] md:tw-text-[13px] tw-font-[500] tw-heading-[20px]'>
          {label}
          {required ? ' *' : ''}
        </div>
      )}
      <div className='tw-relative tw-w-full'>
        <div className='tw-absolute tw-right-2 tw-top-3 tw-pointer-events-none'>
          <DropdownIcon />
        </div>
        <select
          {...formik.getFieldProps(name)}
          className='tw-w-full tw-p-2.5 tw-text-sm tw-text-gray-700 tw-bg-[#F2ECE7] tw-border-none tw-rounded-[5px] tw-outline-none tw-appearance-none'
        >
          <option value=''>{placeholder || 'Select option'}</option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
      <ErrorMessage name={name} component='div' className='error' />
    </div>
  )
}

export default NativeSelect
